@use "../../styles/breakpoint.module.scss" as *;

.filters {
    grid-column: content;
    justify-content: center;
    align-items: center;
    margin-bottom: var(--spacer-48);
}

.carousel {
    composes: root from "../DisplayCarousel/display-carousel.module.scss";
}

.scroller {
    composes: scroller from "../DisplayCarousel/display-carousel.module.scss";
    scrollbar-width: none;

    & > div {
        margin-bottom: 2px;

        --column-count: 5;

        @media ($below-tablet) {
            --column-count: 3;
        }

        @media ($below-mobile) {
            --column-count: 2;
        }
    }
}

.guideTile {
    composes: linkReset from "../Clickables/index.module.scss";
    display: inline-block;
    width: 100%;

    &[data-hovered] {
        box-shadow: var(--box-shadow-2);
    }
}
